import { createReducer, createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    setLanguage: ['language'],
    setUserProfile: ['userProfile']
})

export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
    language: "en",
    userProfile: null
}

/* ------------- Reducers ------------- */
export const userSetUserProfile = (state, { userProfile }) => {
    return Object.assign({}, state, { userProfile });
}

export const userSetLanguage = (state, { language }) => {
    return Object.assign({}, state, { language });
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_LANGUAGE]: userSetLanguage,
    [Types.SET_USER_PROFILE]: userSetUserProfile
})